/**
 *
 * Asynchronously loads the component for SubscriptionPortfoliosPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SubscriptionPortfoliosPage = lazyLoad(
  () => import('./index'),
  module => module.SubscriptionPortfoliosPage,
);
